/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Preview_Empty_AccentsInputs */

const en_us2_search_preview_empty_accents = /** @type {(inputs: Search_Preview_Empty_AccentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accents are optional: gluteo finds Glúteos.`)
};

const pt_br2_search_preview_empty_accents = /** @type {(inputs: Search_Preview_Empty_AccentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem acento também funciona: gluteo encontra Glúteos.`)
};

const es_419_search_preview_empty_accents = /** @type {(inputs: Search_Preview_Empty_AccentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los acentos son opcionales: gluteo encuentra Glúteos.`)
};

const pt_pt2_search_preview_empty_accents = /** @type {(inputs: Search_Preview_Empty_AccentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem acentos também funciona: gluteo encontra Glúteos.`)
};

const fr_fr2_search_preview_empty_accents = /** @type {(inputs: Search_Preview_Empty_AccentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les accents sont facultatifs : epaules trouve Épaules.`)
};

const de_de2_search_preview_empty_accents = /** @type {(inputs: Search_Preview_Empty_AccentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umlaute sind optional: rucken findet Rücken.`)
};

const it_it2_search_preview_empty_accents = /** @type {(inputs: Search_Preview_Empty_AccentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accenti facoltativi: la ricerca trova lo stesso.`)
};

/**
* | output |
* | --- |
* | "Accents are optional: gluteo finds Glúteos." |
*
* @param {Search_Preview_Empty_AccentsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_empty_accents = /** @type {((inputs?: Search_Preview_Empty_AccentsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_Empty_AccentsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_empty_accents(inputs)
	if (locale === "es-419") return es_419_search_preview_empty_accents(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_empty_accents(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_empty_accents(inputs)
	if (locale === "de-DE") return de_de2_search_preview_empty_accents(inputs)
	if (locale === "it-IT") return it_it2_search_preview_empty_accents(inputs)
	return en_us2_search_preview_empty_accents(inputs)
});
export { search_preview_empty_accents as "search.preview_empty_accents" }